export enum EAddressAutocompleteResultType {
  STORE = "store",
  ADDRESS = "address",
  GEOLOCATION = "geolocation",
  DELIVERY_GEOLOCATION = "delivery_geolocation",
  GOOGLE_PLACE = "google_place",
  FALLBACK = "fallback",
}
